import MapWithCouriers from "@/Components/Map/MapWithCouriers";
import useBranch from "@/shared/atoms/useBranch";
import useCourierOrders from "@/shared/hooks/useCourierOrders";
import { orderWithGeo } from "@/shared/v2/utils/helpers";
import { useMemo } from "react";
import useSelectedOrders from "./useSelectedOrders";

const MapOrdersMap = () => {
  const [branch] = useBranch();
  const { orders } = useCourierOrders();
  const selected = useSelectedOrders();

  const geoOrders = useMemo(
    () => (orders ?? []).filter(orderWithGeo),
    [orders]
  );

  return (
    <MapWithCouriers
      routes={selected ?? []}
      orders={geoOrders}
      branch={branch}
      height="100%"
      zoom={13}
    />
  );
};

export default MapOrdersMap;
